import React, { useState, useEffect } from "react";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fileMetaData, passthroughFileMetaData } from "../../utils";
import { get, isNull } from "lodash";
import AddToolTip from "../AddToolTip";
import VariableListSlider from "../../containers/Mapper/MapAndTransformOutput/VariableListSlider";
import SliderPanel from "../SliderPanel";
import { useRouterParams } from "../../abstracts";

const VariableCard = (props) => {
  const {
    index,
    fieldName,
    objName,
    setFieldValue,
    values,
    headerError,
    valueError,
    deserializeHeaderMapJson,
    isSplitConfigured,
  } = props;
  const { flow, profileId, mapType } = useRouterParams();
  const SourceData = deserializeHeaderMapJson?.concat(passthroughFileMetaData);
  const [openSlider, setOpenSlider] = useState(false);
  const targetFileMetaData = isSplitConfigured
    ? SourceData
    : mapType == 3
    ? passthroughFileMetaData
    : fileMetaData;
  const mappedData = isNull(index)
    ? get(values, `${objName}`, {})
    : get(values, `${fieldName}`, {});

  const data = get(mappedData, "value", null);
  const [dataTypeMisMatch, setDataTypeMisMatch] = useState(false);

  useEffect(() => {
    setDataTypeMisMatch(
      mappedData?.value?.dataType != undefined &&
        mappedData?.dataType != undefined
        ? mappedData?.dataType != mappedData?.value?.dataType
          ? true
          : false
        : false
    );
  }, [mappedData]);

  return (
    <div>
      <div className="d-flex justify-content-space-between align-items-center function-card">
        <span
          className="ft-12 ml-3 fw-500 cursor-pointer"
          onClick={() => {
            setOpenSlider(!openSlider);
          }}
        >
          {isNull(data) ? (
            <span className="link-text-mapper fw-400">
              Click to add variable
            </span>
          ) : (
            <div className="ml-2" style={{ lineHeight: "1rem" }}>
              <div
                className="d-flex align-items-center"
                style={{ width: "150px" }}
              >
                <AddToolTip name={data?.displayName} />
              </div>
              <span className="sampleValueText">{data.datum ?? null}</span>
            </div>
          )}
        </span>
        <div>
          {data && (
            <FontAwesomeIcon
              color="#F16973"
              className="ft-16 mr-1 cursor-pointer"
              icon={faTrashAlt}
              onClick={() => {
                isNull(index)
                  ? setFieldValue(`${objName}.value`, null)
                  : setFieldValue(`${fieldName}.value`, null);
              }}
            />
          )}
        </div>
      </div>
      {dataTypeMisMatch && (
        <div className="ft-10 error-text" style={{ lineHeight: "1rem" }}>
          DataType Mismatch
        </div>
      )}
      {(headerError || valueError) && isNull(data) && (
        <div className="ft-12 error-text" style={{ lineHeight: "1rem" }}>
          Required
        </div>
      )}
      <SliderPanel
        isOpen={openSlider}
        size={"30"}
        showCancel={true}
        isMapper={true}
        onClose={() => setOpenSlider(!openSlider)}
      >
        <VariableListSlider
          variableList={targetFileMetaData}
          fieldName={fieldName}
          index={index}
          data={data}
          objName={objName}
          setOpenSlider={setOpenSlider}
        />
      </SliderPanel>
    </div>
  );
};

export default VariableCard;
